import { useState } from "react";
import { errMsg } from "../../lib/api";
import { Btn } from "./AdminParts";

// Admin-only Razorpay connection check; shows mode, masked key and pass/fail only (never secrets).
export function RazorpayCheck({ api }) {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = () => { setBusy(true); api.get("/admin/payments/razorpay-check").then((x) => setR(x.data)).catch((e) => setR({ error: errMsg(e) })).finally(() => setBusy(false)); };
  const Row = ({ ok, label, testid }) => <li className={ok ? "text-emerald-700" : "text-red-700"} data-testid={testid}>{ok ? "PASS" : "FAIL"} · {label}</li>;
  return (
    <div className="card-lux" data-testid="razorpay-check">
      <div className="flex items-center justify-between"><h3 className="text-xl text-[#062a20]">Razorpay connection</h3><Btn onClick={run} disabled={busy} data-testid="razorpay-check-btn">{busy ? "Checking…" : "Test connection"}</Btn></div>
      {r?.error && <p className="text-sm text-red-700 mt-2">{r.error}</p>}
      {r && !r.error && (
        <ul className="text-sm mt-3 space-y-1">
          <Row ok={r.mode === "live"} label={`Mode: ${r.mode || "not set"} (key ${r.key_id_masked || "—"})`} testid="rzp-mode" />
          <Row ok={r.auth_ok} label={r.auth_message} testid="rzp-auth" />
          <Row ok={r.webhook_secret_set} label={`Webhook secret ${r.webhook_secret_set ? "saved" : "missing"} · webhook address ${window.location.origin}${r.webhook_path}`} testid="rzp-webhook" />
          <li className="text-slate-600" data-testid="rzp-last-webhook">Last webhook received: {r.last_webhook ? `${r.last_webhook.event} · ${r.last_webhook.outcome} · ${new Date(r.last_webhook.at).toLocaleString()}` : "none yet"}</li>
          <li className={`font-semibold ${r.ready ? "text-emerald-700" : "text-red-700"}`} data-testid="rzp-ready">{r.ready ? "Ready to accept Live payments" : "Not ready for Live payments"}</li>
        </ul>)}
    </div>);
}
